import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Link } from 'react-router-dom';
import { PurchaseOrder } from '../../types/purchaseOrder';
import { formatDate, formatCurrency } from '../../utils';

interface PurchaseOrderHeaderProps {
  purchaseOrder: PurchaseOrder;
  onDownloadPdf: () => void;
}

const PurchaseOrderHeader: React.FC<PurchaseOrderHeaderProps> = ({
  purchaseOrder,
  onDownloadPdf
}) => {
  const getQuickbooksStatusTag = () => {
    let severity: 'success' | 'warning' | 'danger' | 'info' = 'info';
    let value = 'Unknown';

    if (purchaseOrder.sentToQuickbooks) {
      severity = 'success';
      value = 'Synced';
    } else {
      severity = 'warning';
      value = 'Not Synced';
    }

    return <Tag severity={severity} value={value} />;
  };

  const calculateTotalPrice = () => {
    return purchaseOrder.items.reduce((total, item) => {
      return total + (parseFloat(item.quantity.toString()) * parseFloat(item.unitPrice.toString()));
    }, 0);
  };

  return (
    <div className="grid">
      <div className="col-12 md:col-6">
        <div className="flex align-items-center mb-2">
          <p className="mr-2 mb-0"><strong>PO Number:</strong> {purchaseOrder.poNumber}</p>
          {purchaseOrder.pdfPath && (
            <Button
              icon="pi pi-download"
              onClick={onDownloadPdf}
              className="p-button-text p-button-rounded"
              tooltip="Download Original PDF"
            />
          )}
        </div>
        <p><strong>Client:</strong> {purchaseOrder.client?.name || 'N/A'}</p>
        <p><strong>Status:</strong> {purchaseOrder.status}</p>
        <p><strong>Total Price:</strong> {formatCurrency(calculateTotalPrice())}</p>
      </div>
      <div className="col-12 md:col-6">
        <p><strong>Created At:</strong> {purchaseOrder.createdAt ? formatDate(purchaseOrder.createdAt) : 'N/A'}</p>
        <p><strong>Updated At:</strong> {purchaseOrder.updatedAt ? formatDate(purchaseOrder.updatedAt) : 'N/A'}</p>
        {purchaseOrder.tickets && purchaseOrder.tickets.length > 0 && (
          <p>
            <strong>Linked Ticket:</strong>{' '}
            <Link to={`/tickets/${purchaseOrder.tickets[0].id}`} className="text-primary">
              #{purchaseOrder.tickets[0].id} - {purchaseOrder.tickets[0].title}
            </Link>
          </p>
        )}
        <p><strong>QuickBooks Status:</strong> {getQuickbooksStatusTag()}</p>
      </div>
    </div>
  );
};

export default PurchaseOrderHeader;
